import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [{
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/',
    name: 'dummyHome',
    props: true,
    component() {
      return import('./views/Home.vue');
    },
  },
  {
    path: '/register',
    name: 'registerChoice',
    props: true,
    component() {
      return import('./views/registration/Register.vue');
    },
  },
  {
    path: '/registerPlayer',
    name: 'register',
    props: true,
    component() {
      return import('./views/registration/RegisterPlayer.vue');
    },
    meta: {
      pageTitle: 'Registrierung - CHANCE4TALENTS',
    },
  },
  {
    path: '/registerScout',
    name: 'registerScout',
    component() {
      return import('./views/registration/RegisterScout.vue');
    },
    meta: {
      pageTitle: 'Registrierung - CHANCE4TALENTS',
    },
  },
  {
    path: '/scout/introScout',
    name: 'introScout',
    component() {
      return import('./views/scouts/Intro.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/scout/home',
    name: 'scout_home',
    component() {
      return import('./views/scouts/Home.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/scout/settings',
  //   name: 'scout_home',
  //   component() {
  //     return import('./views/scouts/Settings.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/scout/match',
    name: 'scout_match',
    component() {
      return import('./views/scouts/Match.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/scout/matches',
    name: 'scout_matches',
    component() {
      return import('./views/scouts/Matches.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/scout/chat/:id',
  //   name: 'scoutChat',
  //   component() {
  //     return import('./views/scouts/ScoutChat.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/registerTeam',
    name: 'registerTeam',
    component() {
      return import('./views/registration/RegisterTeam.vue');
    },
    meta: {
      pageTitle: 'Registrierung - CHANCE4TALENTS',
    },
  },
  {
    path: '/team/introTeam',
    name: 'introTeam',
    component() {
      return import('./views/teams/Intro.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/registerTrainer',
    name: 'registerTrainer',
    component() {
      return import('./views/registration/RegisterTrainer.vue');
    },
    meta: {
      pageTitle: 'Registrierung - CHANCE4TALENTS',
    },
  },
  {
    path: '/player/match',
    name: 'match',
    component() {
      return import('./views/players/Match.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/player/matches',
    name: 'matches',
    component() {
      return import('./views/players/Matches.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/player/chat/:id',
  //   name: 'chatPlayer',
  //   props: true,
  //   component() {
  //     return import('./views/players/Chat.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: '/player/settings',
  //   name: 'settings',
  //   component() {
  //     return import('./views/players/Settings.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/player/home',
    name: 'home',
    component() {
      return import('./views/players/Home.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/team/match',
    name: 'team_match',
    component() {
      return import('./views/teams/Match.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/team/matches',
    name: 'team_matches',
    component() {
      return import('./views/teams/Matches.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/team/home',
    name: 'team_home',
    component() {
      return import('./views/teams/Home.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/team/settings',
  //   name: 'team_home',
  //   component() {
  //     return import('./views/teams/Settings.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: '/team/search',
  //   name: 'team_search',
  //   component() {
  //     return import('./views/teams/Search.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: '/team/chat/:id',
  //   name: 'teamChat',
  //   component() {
  //     return import('./views/teams/TeamChat.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/trainer/match',
    name: 'trainer_match',
    component() {
      return import('./views/trainers/Match.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/trainer/matches',
    name: 'trainer_matches',
    component() {
      return import('./views/trainers/Matches.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/trainer/home',
    name: 'trainer_home',
    component() {
      return import('./views/trainers/Home.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/trainer/settings',
  //   name: 'trainer_home',
  //   component() {
  //     return import('./views/trainers/Settings.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: '/trainer/chat/:id',
  //   name: 'trainerChat',
  //   component() {
  //     return import('./views/trainers/Chat.vue');
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/chat/:id/:type',
    name: 'chat',
    component() {
      return import('./views/chat/Chat.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/activate-account/:uid/:type',
    name: 'activate-account',
    component() {
      return import('./views/Activate.vue');
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/payment',
    name: 'payment',
    component() {
      return import('./views/payment/Payment.vue');
    },
  },
  {
    path: '/stripe',
    name: 'stripe',
    component() {
      return import('./views/payment/StripePayment.vue');
    },
  },
  {
    path: '/stripe/process',
    name: 'stripe_process',
    component() {
      return import('./views/payment/StripePaymentProcess.vue');
    },
  },
  {
    path: '/stripe/done',
    name: 'stripe_done',
    component() {
      return import('./views/payment/StripePaymentDone.vue');
    },
  },
  {
    path: '/cancelation',
    name: 'cancelation',
    component() {
      return import('./views/Cancelation.vue');
    },
  },
  {
    path: '/user/update',
    name: 'userUpdate',
    component() {
      return import('./views/registration/UpdatePlayer.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/trainer/update',
    name: 'trainerUpdate',
    component() {
      return import('./views/registration/UpdateTrainer.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/team/update',
    name: 'teamUpdate',
    component() {
      return import('./views/registration/UpdateTeam.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/scout/update',
    name: 'scoutUpdate',
    component() {
      return import('./views/registration/UpdateScout.vue');
    },
    meta: {
      requiresAuth: true,
    },
  },
  ],
});
